import { __decorate } from "tslib";
import { lazyConsumer } from '@1inch-community/core/lazy';
import { observe } from '@1inch-community/core/lit-utils';
import { scrollContext } from '@1inch-community/ui-components/scroll';
import { html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { defer } from 'rxjs';
import '../../../chain-selector';
import { selectTokenContext } from '../../context';
import '../favorite-tokens';
import '../search-token-input';
import { selectTokenHeaderStyle } from './select-token-header.style';
let SelectTokenHeaderElement = class SelectTokenHeaderElement extends LitElement {
    constructor() {
        super(...arguments);
        this.selectTokenContext = lazyConsumer(this, { context: selectTokenContext });
        this.scrollContext = lazyConsumer(this, { context: scrollContext });
        this.chainListView$ = defer(() => this.selectTokenContext.value.chainFilter$);
    }
    static { this.tagName = 'inch-select-token-header'; }
    static { this.styles = selectTokenHeaderStyle; }
    render() {
        return html `
      <div style="margin-left: 1px; margin-right: 1px; pointer-events: auto;">
        <inch-card-header backButton>
          <inch-chain-selector
            slot="center-container"
            .selectedChainIdList="${observe(this.chainListView$)}"
            @changeSelectedChainIdList="${(event) => this.selectTokenContext.value.onChangeChainFilter(event.detail.value)}"
          ></inch-chain-selector>
        </inch-card-header>
        <inch-search-token-input></inch-search-token-input>
        <inch-favorite-tokens></inch-favorite-tokens>
      </div>
    `;
    }
};
SelectTokenHeaderElement = __decorate([
    customElement(SelectTokenHeaderElement.tagName)
], SelectTokenHeaderElement);
export { SelectTokenHeaderElement };
//# sourceMappingURL=select-token-header.element.js.map